import React from 'react';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import './Large-Image-Component-With-Title-Subtitle-Body.scss';

const LargeImageComponentWithBodyAndBackgroundPreview = (props) => {
  const { config } = props;

  return (
    <div className='large-image-with-body-cta'>
      {config && (
        <div>
          <div className='preview-title'>{config?.titleH1 ? config?.titleH1 : 'H1 Title'}</div>
          <div
            style={{
              backgroundColor: config?.backgroundColor || '#8f8f8f',
            }}
            className={`large-image-with-body-cta-box ${
              config?.shadowOverlay ? 'shadowed-img' : ''
            }`}
          >
            {!config?.isVideo && (
              <div
                className='d-flex align-items-center justify-content-center h-100 large-image-with-background-image-container'
                style={
                  config?.imgURL
                    ? {
                        backgroundImage: 'url(' + ASSET_URL + config?.imgURL + ')',
                        backgroundSize: 'cover',
                      }
                    : {}
                }
              >
                <div className='slide-title'>{config?.imgURL ? '' : 'Large Image'}</div>
              </div>
            )}
            {config?.isVideo && (
              <div className={`${config?.shadowOverlay ? 'shadowed-img' : ''}`}>
                <video
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'fill',
                    position: 'relative',
                    top: 0,
                    left: 0,
                  }}
                  autoPlay
                  loop={config?.loopPlayBack}
                  preload='auto'
                  src={config?.videoURL}
                  muted
                />
              </div>
            )}
            <div className='preview-title  h3title'>
              {config?.titleH3 ? config?.titleH3 : 'H3 Title'}
            </div>
            <div className='preview-body mb-2'>
              <p className='preview-breaks'>{config?.body ? config?.body : 'Body'}</p>
            </div>
            {config?.cta?.isActive && (
              <div className='preview-cta'>{config?.cta?.title ? config?.cta?.title : 'CTA'}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LargeImageComponentWithBodyAndBackgroundPreview;
